export default {
    state: {
        ssProcessing: false,
        ssError: null,
        ssProductTypes: [],
        ssPaymentsList: [],
        ssTermsConditions: null,
        availableStepMerchandise: false,
        ssSmsNotificationFee: null,
    },
    mutations: {
        ssSetProcessing(state, payload) {
          state.ssProcessing = payload
        },
        ssSetError(state, payload) {
            state.ssError = payload
        },
        ssClearError(state) {
            state.ssError = null
        },
        ssSetProductTypes(state, payload) {
            state.ssProductTypes = payload
        },
        ssSetPaymentsList(state, payload) {
            state.ssPaymentsList = payload
        },
        ssSetTermsConditions(state, payload) {
            state.ssTermsConditions = payload
        },
        ssSetAvailableStepMerchandise(state, payload) {
            state.availableStepMerchandise = payload
        },
        ssSetSmsNotificationFee(state, payload) {
            state.ssSmsNotificationFee = payload
        },
    },
    actions: {
        ssSetProcessing ({commit}, payload) {
            commit('ssSetProcessing', payload)
        },
        ssSetError ({commit}, payload) {
            commit('ssSetError', payload)
        },
        ssClearError ({commit}) {
            commit('ssClearError')
        },
        ssSetProductTypes ({commit}, payload) {
            commit('ssSetProductTypes', payload)
        },
        ssSetPaymentsList ({commit}, payload) {
            commit('ssSetPaymentsList', payload)
        },
        ssSetTermsConditions ({commit}, payload) {
            commit('ssSetTermsConditions', payload)
        },
        ssSetAvailableStepMerchandise ({commit}, payload) {
            commit('ssSetAvailableStepMerchandise', payload)
        },
        ssSetSmsNotificationFee ({commit}, payload) {
            commit('ssSetSmsNotificationFee', payload)
        },
    },
    getters: {
        ssGetProcessing: (state) => state.ssProcessing,
        ssGetError: (state) => state.ssError,

        ssIsSetProductTypes: (state) => state.ssProductTypes.length,
        ssGetProductTypes: (state) => state.ssProductTypes,

        ssIsSetPaymentsList: (state) => state.ssPaymentsList.length,
        ssGetPaymentsList: (state) => state.ssPaymentsList,

        ssGetTermsConditions: (state) => state.ssTermsConditions,

        ssAvailableStepMerchandise: (state) => state.availableStepMerchandise,

        ssSmsNotificationFee: (state) => state.ssSmsNotificationFee,
    }
}
